import { forceChangePasswordFields } from "./fields";
import { reduxForm } from "redux-form";
import Button from "components/atoms/Button";
import ReduxFormFields from "components/molecules/ReduxFormFields";
import { Typography } from "@mui/material";

function ForceChangePasswordForm({ handleSubmit }: any) {
  return (
    <div>
      <Typography variant="body2" sx={{ mb: 2 }} color="text.secondary">
        Your password must be at least 8 characters and include an uppercase
        letter, a lowercase letter, a number, and a symbol.
      </Typography>
      <form onSubmit={handleSubmit}>
        <ReduxFormFields fields={forceChangePasswordFields} />
        <br />
        <Button
          color="primary"
          variant="contained"
          fullWidth
          type="submit"
          sx={{ paddingY: "8px" }}
        >
          Update password
        </Button>
      </form>
    </div>
  );
}

export default reduxForm({ form: "ForceChangePasswordForm" })(
  ForceChangePasswordForm
);
